import t from 'vivino-js/translationString';
import { Closure } from 'vivino-ui/icons/WineFacts';

const TRANSLATION_PATH = 'components.shared.wine_summary';
const TRANSLATIONS = {
  closure: `${TRANSLATION_PATH}.closure`,
  stelvin: `${TRANSLATION_PATH}.stelvin`,
  ardeaseal: `${TRANSLATION_PATH}.ardeaseal`,
  zork: `${TRANSLATION_PATH}.zork`,
  vinolok: `${TRANSLATION_PATH}.vinolok`,
  synthetic: `${TRANSLATION_PATH}.synthetic`,
  cork: `${TRANSLATION_PATH}.cork`,
  screw: `${TRANSLATION_PATH}.screw`,
};

export const getBottleClosureFact = (vintage, translationFunc = t) => {
  const closure = vintage?.wine_facts?.closure;
  const key = TRANSLATIONS[closure];
  if (!closure || !key) {
    return null;
  }
  return {
    key: 'bottleClosure',
    headerLabel: translationFunc(TRANSLATIONS.closure),
    icon: Closure,
    values: [{ name: t(key) }],
  };
};
